define([
	'internal_util/Configuration',
	'internal_util/Util',
	'internal_util/ClientUtil',
	'model/Error',
	'model/ErrorType',
	'amdi18n-loader?!internal_util/nls/Logger_strings',
	'lib/jquery'
], function (
	Configuration,
	Util,
	ClientUtil,
	Error,
	ErrorType,
	Strings,
	jQuery
) {
	'use strict';

	var _logBuffer = new Array();


	// private methods

	function getUTCString(date) {
		date = new Date(date);

		return (date.getUTCDate() < 10 ? '0' + date.getUTCDate() : date.getUTCDate()) +
				'.' +
				((date.getUTCMonth() + 1) < 10 ? '0' + (date.getUTCMonth() + 1) : (date.getUTCMonth()) + 1) +
				'.' +
				date.getUTCFullYear() + ' ' +
				(date.getUTCHours() < 10 ? '0' + date.getUTCHours() : date.getUTCHours()) +
				':' +
				(date.getUTCMinutes() < 10 ? '0' + date.getUTCMinutes() : date.getUTCMinutes()) +
				':' +
				(date.getUTCSeconds() < 10 ? '0' + date.getUTCSeconds() : date.getUTCSeconds()) +
				' UTC';
	}


	// public methods

	function getReport() {
		var report = '',
			clientInfo = ClientUtil.getClientInfo(),
			i;

		report += '\nSystem Info:\n\n' +
				'User Agent: ' + clientInfo['userAgent'] + '\n' +
				'Platform: ' + clientInfo['platform'] + '\n' +
				'Locale: ' + clientInfo['locale'] + '\n';

		report += '\n\nLog:\n\n';

		for (i = (_logBuffer.length - 1); i >= 0; i--) {
			report += getUTCString(_logBuffer[i]['date']) + ': ' +
					_logBuffer[i]['class'] + '.' +
					_logBuffer[i]['method'] + '(): ' +
					_logBuffer[i]['message'];

			if (_logBuffer[i]['data'] !== null) {
				report += ': ' + Util.toString(_logBuffer[i]['data']) + '\n';
			} else {
				report += '\n';
			}
		}

		return report;
	}

	function getLastLogMessage() {
		var lastLogIndex = _logBuffer.length - 1;

		if (lastLogIndex === -1) {
			return null;
		}

		return _logBuffer[lastLogIndex]['message']
				+ ': '
				+ Util.toString(_logBuffer[lastLogIndex]['data']);
	}

	function getLastError() {
		var error = null,
			i;

		for (i = _logBuffer.length - 1; i >= 0; i--) {
			if (_logBuffer[i]['data'] instanceof Error || error === null) {
				if (_logBuffer[i]['data'] instanceof Error) {
					error = _logBuffer[i]['data'];
				}
			} else {
				break;
			}
		}

		return error;
	}

	function uploadReport(name, email, information, callbacks, errorCallbacks) {
		var baseURL = Configuration.get('REPORT_URL'),
			headers = Configuration.get('REPORT_HEADERS'),
			data = Configuration.get('REPORT_DATA'),
			reportFileName = 'error_report.txt',
			reportContentType = 'text/plain',
			error = getLastError();

		if (baseURL === null) {
			return;
		} else if (!Util.isValidURL(baseURL)) {
			log('Logger', 'uploadReport', Strings.invalid_report_url, baseURL);
		}

		if (error !== null) {
			data['issue']['subject'] += ': ' + error.message();
//			try {
//				var t = JSON.parse(error.data().responseText);
//				if (t.hasOwnProperty("Code")) {
//					data['issue']['subject'] += " ("+data.Code+")";
//				}
//			} catch(e) {
//				//No error-code given
//			}
		}

		data['issue']['description'] = 'Name: ' + (Util.isValidString(name) ? name : '-') +
				'\ne-Mail: ' + (Util.isValidString(email) ? email : '-') +
				'\n\nMore information: ' + (Util.isValidString(information) ? information : '-');

		jQuery.ajax({
			url : baseURL + '/uploads.json',
			type : 'POST',
			headers : headers,
			contentType : 'application/octet-stream',
			data : getReport(),
			success : function (response) {
				if (typeof response !== 'object' || !response.hasOwnProperty('upload')) {
					Util.callCallbacks(errorCallbacks, response);
					return;
				}

				response['upload']['filename'] = reportFileName;
				response['upload']['content_type'] = reportContentType;

				data['issue']['uploads'] = [ response['upload'] ];

				jQuery.ajax({
					url : baseURL + '/issues.json',
					type : 'POST',
					headers : headers,
					contentType : 'application/json',
					data : JSON.stringify(data),
					success : function () {
						Util.callCallbacks(callbacks);
					},
					error : function (jqXHR) {
						Util.callCallbacks(errorCallbacks, jqXHR);
					}
				});
			},
			error : function (jqXHR) {
				Util.callCallbacks(errorCallbacks, jqXHR);
			}
		});
	}

	function log(clazz, method, message, data) {
		data = (typeof data !== 'undefined') ? data : null;

		_logBuffer.push({'date' : (new Date()).getTime(), 'class' : clazz,
				method : method, message : message, data : data});

		if (Configuration.get('DEBUG') && typeof console !== 'undefined') {
			if (data !== null) {
				console.log(clazz + '.' + method + '(): ' + message + ': ' + Util.toString(data));
			} else {
				console.log(clazz + '.' + method + '(): ' + message);
			}
		}
	}

	return {
		getReport : getReport,
		getLastLogMessage : getLastLogMessage,
		getLastError : getLastError,
		uploadReport : uploadReport,
		log : log
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/util/Logger.js
// module id = 2
// module chunks = 6